import { Link } from "react-router-dom";
import { formatBoon, formatRelative, formatUsdc } from "../../lib/api";
import { reviewStableKey, type X402ReviewerReviewItem } from "../../lib/x402Discovery";

export function X402ReviewerReviewList({ items }: { items: X402ReviewerReviewItem[] }) {
  return (
    <div className="border border-faint bg-faint grid gap-px rounded-md overflow-hidden">
      {items.map((item) => {
        return (
          <article key={item.routeId + ":" + reviewStableKey(item.review)} className="bg-paper p-5 md:p-7">
            <div className="min-w-0">
                <p className="btn-mono text-[10px] uppercase tracking-[0.14em] text-muted">
                  {item.review.evidenceKind === "boon_backed" ? "Boon-backed review" : item.review.evidenceKind === "receipt_verified" ? "Receipt-verified usage review" : "Self-reported review"}
                </p>
                <h3 className="mt-2 text-xl md:text-2xl font-display tracking-tight">
                  <Link className="hover:text-olive-deep hover:underline" to={"/x402/routes/" + item.routeId}>
                    {item.description?.summary ?? "Route " + item.routeId.slice(0, 10) + "…"}
                  </Link>
                </h3>
                {item.description && (
                  <p className="mt-2 btn-mono text-xs text-olive-deep break-all">
                    {item.description.route.method} {item.description.route.publicEndpointUrl}
                  </p>
                )}
              </div>

            <blockquote className="mt-5 border-l-4 border-olive pl-5 text-xl md:text-2xl font-display leading-snug text-ink">
              “{item.review.reviewText}”
            </blockquote>

            <div className="mt-5 flex flex-wrap gap-x-6 gap-y-3 border-t border-faint pt-4 text-xs btn-mono text-muted">
              {item.review.evidenceKind === "boon_backed" ? (
                <>
                  <span>{formatUsdc(item.review.recognition.totalRecognitionUsdc)} gratitude</span>
                  <span>{formatBoon(item.review.recognition.boonBurned)} burned</span>
                  <a
                    className="text-olive-deep hover:underline"
                    href={"https://basescan.org/tx/" + item.review.recognition.transactionHash}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Boon receipt ↗
                  </a>
                </>
              ) : item.review.evidenceKind === "receipt_verified" ? (
                <>
                  <span>x402 payer receipt</span>
                  <span>visible volume · unranked</span>
                  {item.review.receipt.transaction && (
                    <a
                      className="text-olive-deep hover:underline"
                      href={"https://basescan.org/tx/" + item.review.receipt.transaction}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      payment ↗
                    </a>
                  )}
                </>
              ) : (
                <>
                  <span>wallet signature only</span>
                  <span>$0.05 anti-spam publication</span>
                  <span>visible volume · unranked</span>
                </>
              )}
              <span>{formatRelative(String(item.review.createdAt))}</span>
            </div>
          </article>
        );
      })}
    </div>
  );
}
